import {Component, computed, input} from '@angular/core';


@Component({
  selector: 'app-badge',
  standalone: true,
  imports: [],
  templateUrl: './badge.component.html',
  styleUrl: './badge.component.css'
})
export class BadgeComponent {
  variant = input<'green' | 'blue' | 'red' | 'purple' | 'grey'>('green');
  class = input<string>('');

  badgeClass = computed(() => {
    const variantClasses = {
      green: 'bg-green-100 text-green-800 text-xs font-medium px-1 py-0.5 rounded-sm dark:bg-green-900 dark:text-green-300',
      blue: 'bg-blue-100 text-blue-800 text-xs font-medium px-1 py-0.5 rounded-sm dark:bg-blue-900 dark:text-blue-300',
      red: 'bg-red-100 text-red-800 text-xs font-medium px-1 py-0.5 rounded-sm dark:bg-red-900 dark:text-red-300',
      purple: 'bg-purple-100 text-purple-800 text-xs font-medium px-1 py-0.5 rounded-sm dark:bg-purple-900 dark:text-purple-300',
      grey: 'bg-gray-100 text-gray-800 text-xs font-medium px-1 py-0.5 rounded-sm dark:bg-gray-900 dark:text-gray-300',
    };
    return `${variantClasses[this.variant()]} ${this.class()}`;
  });
}
